var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    {
      staticClass: "price-item",
      class: { mt: !_vm.mostOftenChosen && _vm.$wf.isLgUp },
      attrs: { grow: "" },
    },
    [
      _c(
        "w-card-content",
        { attrs: { grow: "" } },
        [
          _vm.mostOftenChosen
            ? _c("div", { staticClass: "most" }, [
                _vm._v(" " + _vm._s(_vm.$ct("most")) + " "),
              ])
            : _vm._e(),
          _c("p", { staticClass: "subtitle" }, [
            _vm._v(" " + _vm._s(_vm.$ct(`subtitle.tier${_vm.tier}`)) + " "),
          ]),
          _c("h2", { staticClass: "title" }, [
            _vm._v(" " + _vm._s(_vm.$ct(`common.tiers.${_vm.tier}`)) + " "),
          ]),
          _vm.isDemoVersionSelected
            ? _c("p", { staticClass: "demo-time" }, [
                _vm._v(" " + _vm._s(_vm.demoTimeRemaining) + " "),
              ])
            : [
                _vm.tier < 2
                  ? [
                      _c("p", { staticClass: "pricing" }, [
                        _vm._v(" €" + _vm._s(_vm.price) + " "),
                      ]),
                      _c("p", { staticClass: "pricing-sub" }, [
                        _vm._v(" " + _vm._s(_vm.pricingSubLabel) + " "),
                      ]),
                    ]
                  : _vm.tier == 2
                  ? [
                      _c("p", { staticClass: "pricing" }, [
                        _vm._v(_vm._s(_vm.$ct("enterprice-pricing"))),
                      ]),
                      _c("p", { staticClass: "pricing-sub" }, [_vm._v(" ​ ")]),
                    ]
                  : [
                      _c("p", { staticClass: "pricing" }, [_vm._v(" - ")]),
                      _c("p", { staticClass: "pricing-sub" }, [
                        _vm._v(" " + _vm._s(_vm.$ct("soon")) + " "),
                      ]),
                    ],
              ],
          _c(
            "div",
            { staticClass: "button-box" },
            [
              _vm.tier <= 2 && !_vm.buttonDisabled
                ? _c(
                    "w-button",
                    {
                      staticClass: "order-button",
                      style: { flexGrow: 1 },
                      attrs: { disabled: _vm.buttonDisabled },
                      on: {
                        click: function ($event) {
                          return _vm.order()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]
                  )
                : _vm._e(),
              _vm.buttonDisabled
                ? _c("p", {
                    directives: [
                      {
                        name: "safe-html",
                        rawName: "v-safe-html",
                        value: _vm.buttonText,
                        expression: "buttonText",
                      },
                    ],
                    staticClass: "soon",
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("ul", { staticClass: "options" }, [_vm._t("default")], 2),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }